import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import NumberField from "../../../../../Shared/fields/NumberField";
import { setOpening } from "../actions";

class TooltipBody extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      appointment: props.data,
    };
  }

  getMaxOverBookQuota = (quota) => {
    if (quota.Description === "Ocupacional")
      return quota.OverbookedMaximumAmount < this.props.centerConfig.maxOverBookOcupational ? quota.OverbookedMaximumAmount : this.props.centerConfig.maxOverBookOcupational;
    if (quota.Description === "Preocupacional")
      return quota.OverbookedMaximumAmount < this.props.centerConfig.maxOverBookPreocupational ? quota.OverbookedMaximumAmount : this.props.centerConfig.maxOverBookPreocupational;
    if (quota.Description === "Ciel")
      return quota.OverbookedMaximumAmount < this.props.centerConfig.maxOverBookCiel ? quota.OverbookedMaximumAmount : this.props.centerConfig.maxOverBookCiel;
    return quota.OverbookedMaximumAmount;
  }

  getDisabledQuota = (quota) => {

    if (quota.Description === "Ocupacional")
      return !this.props.centerConfig.canOverBookOcupational;
    if (quota.Description === "Preocupacional")
      return !this.props.centerConfig.canOverBookPreocupational;
    if (quota.Description === "Ciel")
      return !this.props.centerConfig.canOverBookCiel;
    return false;
  }

  handleChange = (e, quotaType, amountType) => {
    const newQuota = { ...this.state.appointment };

    const editedQuotas = newQuota.Quotas.map((q) => {
      if (q.Quota.Description === quotaType) {
        const newQ = { ...q };
        newQ[amountType] = e.value;
        return newQ;
      }
      return q;
    });

    newQuota.Quotas = editedQuotas;

    this.setState({ appointment: newQuota });
  }

  handleRow = () => {
    const newOpening = { ...this.props.Opening };
    const newData = newOpening.data.map((item) => {
      if (item.endDateInt === this.state.appointment.endDateInt
        && item.startDateInt === this.state.appointment.startDateInt) {
        return { ...item, Quotas: this.state.appointment.Quotas };
      }
      return item;
    });
    if (newOpening.IdConfig > 0) {
      newOpening.isNewConfig = true;
    }
    newOpening.data = newData;
    this.props.dispatch(setOpening(newOpening));
  }

  handleColumn = (e) => {
    const newOpening = { ...this.props.Opening };
    const newData = newOpening.data.map((item) => {
      if (item.day === this.state.appointment.day) {
        return { ...item, Quotas: this.state.appointment.Quotas };
      }
      return item;
    });
    if (newOpening.IdConfig > 0) {
      newOpening.isNewConfig = true;
    }
    newOpening.data = newData;
    this.props.dispatch(setOpening(newOpening));
  }
  handleWeek = () => {
    const newOpening = { ...this.props.Opening };
    const newData = newOpening.data.map((item) => ({ ...item, Quotas: this.state.appointment.Quotas }));
    if (newOpening.IdConfig > 0) {
      newOpening.isNewConfig = true;
    }
    newOpening.data = newData;
    this.props.dispatch(setOpening(newOpening));
  }

  render() {
    const { appointment } = this.state;
    return (
      <div className="scheduler-tooltip" style={{ minHeight: 360, minWidth: 400 }}>
        <div className="cupos-wrapper">
          {appointment.Quotas && appointment.Quotas.map((item, index) => (
            <div className="row" key={item.Quota.Description}>
              <div className="col-6">
                {item.Quota.Status !== 0 && 
                  <NumberField
                    id={`cupos${item.Quota.Description}`}
                    inputAttr={{ maxLength: 4 }}
                    label={item.Quota.Description}
                    min={0}
                    max={1000}
                    value={appointment[`cupos${item.Quota.Description}`] || item.AmmountQuota}
                    onChange={(data) => this.handleChange(data, item.Quota.Description, "AmmountQuota", index)}
                    showSpinButtons
                  />
                }
              </div>
              <div className="col-6">
              {item.Quota.Status !== 0 && 
                <NumberField
                  id={`sobreCupo${item.Quota.Description}`}
                  disabled={this.getDisabledQuota(item.Quota)}
                  inputAttr={{ maxLength: 4 }}
                  min={0}
                  max={1000}
                  max={this.getMaxOverBookQuota(item.Quota)}
                  label={`Sobrecupo ${item.Quota.Description}`}
                  value={appointment[`sobreCupo${item.Quota.Description}`] || item.AmmountOverQuota}
                  onChange={(data) => this.handleChange(data, item.Quota.Description, "AmmountOverQuota", index)}
                  showSpinButtons
                />
              }
              </div>
            </div>
          ))}
        </div>

        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-12">
            <h3><p>Repetir en: </p></h3>
          </div>
          <div className="col-4">
            <Button
              onClick={this.handleRow}
              text="Módulo"
              type="success"
              width="100%"
              stylingMode="outlined"
            />
          </div>
          <div className="col-4">
            <Button
              onClick={this.handleColumn}
              text="Dia"
              width="100%"
              type="success"
              stylingMode="outlined"
            />
          </div>
          <div className="col-4">
            <Button
              onClick={this.handleWeek}
              type="success"
              width="100%"
              text="Semana"
              stylingMode="outlined"
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Opening: state.aperturasSel.Opening,
  centerConfig: state.aperturasSel.centerConfig,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TooltipBody);
